import React, {Component} from 'react';
import {styled} from '@material-ui/core/styles';
import {Box, Button, RadioGroup, FormControlLabel, Radio} from '@material-ui/core';
import {BASE_URL} from '../../../store/config';
import ClientIndividual from './ClientIndividual';
import ClientCorporation from './ClientCorporation';
import instance from '../../../request/http'
import Toast from '../../Layout/components/Toast';
import { ADD, EDIT, VIEW } from '../../../common/common';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textWapper': {
        width: '100%',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
    },
    '& .notesText': {
        width: '100%',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const INDIVIDUAL = "individual";
const CORPORATION = "corporation";

class Client extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            radioValue: 0,
            users: [],
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }

    render() {
        const {title, data, state, hideType} = this.props;
        const {
            radioValue,
            users,
            showToast,
            toastMsg,
            toastState
        } = this.state;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary"
                               onClick={this.handleCreate}>{this.btnName(this.props.state)}</Button>
            }
        }
        const checkInfo = () => {
            if (radioValue === INDIVIDUAL) {
                return <ClientIndividual
                    ref={(child) => {
                        this.clientIndividual = child
                    }}
                    users={users}
                    state={state}
                    data={data}
                ></ClientIndividual>
            } else if (radioValue === CORPORATION) {
                return <ClientCorporation
                    ref={(child) => {
                        this.clientCorporation = child
                    }}
                    users={users}
                    state={state}
                    data={data}
                ></ClientCorporation>
            }
        }
        return (
            <Root>
                <div className="pageTitle">{title}</div>
                <div className="line"></div>
                <div className="textWapper">
                    <div className="title">Client Info</div>
                    {
                        hideType ? "" :
                            <RadioGroup
                                aria-label="Gender"
                                name="gender1"
                                row
                                value={radioValue}
                                onChange={this.handleRadio}
                            >
                                <FormControlLabel disabled={state === ADD ? false : true} value={INDIVIDUAL}
                                                  control={<Radio color="primary"/>} label="Individual"/>
                                <FormControlLabel disabled={state === ADD ? false : true} value={CORPORATION}
                                                  control={<Radio color="primary"/>} label="Corporation"/>
                            </RadioGroup>
                    }
                    {checkInfo()}
                </div>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }

    componentDidMount() {
        this.getUsers(() => {
            this.initData();
        });
    }

    initData() {
        const {ICType} = this.props;
        if (ICType === 0) {
            this.setState(() => ({
                radioValue: INDIVIDUAL
            }));
        } else if (ICType === 1) {
            this.setState(() => ({
                radioValue: CORPORATION
            }));
        } else {
            this.setState(() => ({
                radioValue: INDIVIDUAL
            }));
        }
    }

    isDisabled() {
        const {state} = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }

    handleRadio(e) {
        let radioValue = e.target.value;
        this.setState(() => ({
            radioValue
        }))
    }

    handleCreate() {
        const {radioValue} = this.state;
        let data = "";
        let canCreate = true;
        if (radioValue === INDIVIDUAL) {
            data = this.clientIndividual.handleGetData();
            canCreate = this.verifyI(data);
        } else if (radioValue === CORPORATION) {
            data = this.clientCorporation.handleGetData();
            canCreate = this.verifyC(data);
        }
        console.log(radioValue)
        if (canCreate) this.props.handleCreate(radioValue, data)
    }

    verifyI(data) {
        if (data.first_name === "") {
            this.showToast("Please fill in the first name", "warning")
            return false;
        } else if (data.last_name === "") {
            this.showToast("Please fill in the last name", "warning")
            return false;
        } else if (data.email === "" && data.phone === "" && data.wechat === "") {
            this.showToast("Please fill in WeChat or email or phone", "warning")
            return false;
            // } else if (data.handlers[0].handler_id === "") {
            //     this.showToast("Please choose Originating Attorney", "warning")
            //     return false;
        } else {
            return true;
        }
    }

    verifyC(data) {
        if (data.name === "") {
            this.showToast("Please fill in the company name", "warning")
            return false;
        } else if (data.email === "" && data.phone === "" && data.wechat === "") {
            this.showToast("Please fill in WeChat or email or phone", "warning")
            return false;
        }
        // else if (data.contacts[0].full_name === "") {
        //     this.showToast("Please fill in the name of the contact", "warning")
        //     return false;
        // } else if (data.contacts[0].email === "" && data.contacts[0].phone === "" && data.contacts[0].wechat === "") {
        //     this.showToast("Please fill in the email or WeChat or phone of the contact", "warning")
        //     return false;
        //     // } else if (data.handlers[0].handler_id === "") {
        //     //     this.showToast("Please choose Originating Attorney", "warning")
        //     //     return false;
        // }
        else {
            return true;
        }
    }

    handleCancel() {
        this.props.handleCancel();
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    getUsers(callback) {
        let params = {
            page_index: 1,
            page_size: 100
        }
        instance.get(BASE_URL + 'users', {params}).then((res) => {
            let users = res.data.data
            this.setState({
                users
            }, () => {
                callback();
            });
        })
    }

    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default Client;